export default __webpack_public_path__ + "static/media/4-TCMGroup.efbb73fd.png";